import { callApi } from './Api';
import { actionCreator } from './helpers';
import { getClientTags } from './Clients'
import { push } from 'react-router-redux';

export const CLEAR_INSIGHT_TAG_INFO = "CLEAR_INSIGHT_TAG_INFO"
export const GENERATE_TAG = "GENERATE_TAG"
export const UPDATE_TAG = "UPDATE_TAG"
export const SAVE_TAG = "SAVE_TAG"
export const CLEAR_TAG_ERROR = "CLEAR_TAG_ERROR"
export const GET_TAG_DETAIL = "GET_TAG_DETAIL"
export const TAG_WEBSITE_NAME = 'TAG_WEBSITE_NAME'
export const TAG_WEBSITE_URL = "TAG_WEBSITE_URL"
export const TAG_CAMPAIGN_NAME = "TAG_CAMPAIGN_NAME"
export const ADD_TAG_VARIABLE = "ADD_TAG_VARIABLE"

export const setTagWebsiteName = actionCreator(TAG_WEBSITE_NAME)
export const setTagWebsiteURL = actionCreator(TAG_WEBSITE_URL)
export const setTagCampaignName = actionCreator(TAG_CAMPAIGN_NAME)
export const clearInsightTagInfo = actionCreator(CLEAR_INSIGHT_TAG_INFO)
export const clearTagError = actionCreator(CLEAR_TAG_ERROR)

export const generateTag = (clientId, data) =>{
	return (dispatch, getState) => {
		const url = `clients/${clientId}/tags`
		callApi(dispatch, getState, data.id ? UPDATE_TAG : GENERATE_TAG, url, {
			method: 'POST',
			body: JSON.stringify(data)
		})
	}
}

export const saveTag = (clientId, uuid, data) =>{
	return (dispatch, getState) => {
		const url = `clients/${clientId}/tags/${uuid}`
		callApi(dispatch, getState, SAVE_TAG, url, {
			method: 'POST',
			body: JSON.stringify(data)
		},{
				success: () => {
					dispatch(getClientTags(clientId))
					dispatch(push('/insights/tags/list'))
				}
			})
	}
}

export const fetchTagDetail = (clientId, tagid) => {
	return (dispatch, getState) => {
		const url = `clients/${clientId}/tags/${tagid}`
		callApi(dispatch, getState, GET_TAG_DETAIL, url)
	}
}

export const getTagDetail = (clientId, tagid, redirectUrl) => {
	return (dispatch, getState) => {
		const url = `clients/${clientId}/tags/${tagid}`
		callApi(dispatch, getState, GET_TAG_DETAIL, url, {}, {
			success: () => {
				dispatch(push(redirectUrl ? redirectUrl : '/insights/tags/detail'))
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/actions/tags.js